import { Product, ProductTravellerType } from '@ridango/components/lib/purchase/purchase.model';
import { TranslateObjectFieldPipe } from '@ridango/core';
import { UserProfileInfo } from './product.component.model';

type TranslateInstant = {
    instant(key: string): string;
};

export class ProductComponentUtil {
    static getUserProfilesInfo(
        productTravellerType: ProductTravellerType,
        translatePipe: TranslateObjectFieldPipe,
        translate: TranslateInstant,
        currentLanguage: string
    ): string {
        const userProfiles = (productTravellerType?.userProfiles || []) as UserProfileInfo[];

        return userProfiles
            .map((userProfile) => {
                const profileName = translatePipe.transform(userProfile?.name, null, currentLanguage) || '';
                const ageInfo = ProductComponentUtil.getUserProfileAgeInfo(userProfile, translate);
                const personsInfo = ProductComponentUtil.getUserProfilePersonsInfo(userProfile, translate);

                return [profileName, ageInfo, personsInfo].filter(Boolean).join(', ');
            })
            .filter(Boolean)
            .join(', ');
    }

    static getNewAFCproductDescription(products: Product[], currentLanguage: string): string | null {
        const productDesc = products?.[0]?.description?.translations.find(
            (t) => t.lang === currentLanguage
        )?.translation;

        return productDesc ?? null;
    }

    static getUserProfileAgeInfo(
        userProfile: Pick<UserProfileInfo, 'minAge' | 'maxAge'>,
        translate: TranslateInstant
    ): string | null {
        const ageUnit = translate.instant('PURCHASE_V2_PRODUCT_USER_PROFILE_AGE_UNIT');

        if (userProfile?.minAge != null && userProfile?.maxAge != null) {
            return `${userProfile.minAge}-${userProfile.maxAge} ${ageUnit}`;
        }

        if (userProfile?.minAge != null) {
            return `${userProfile.minAge}+ ${ageUnit}`;
        }

        if (userProfile?.maxAge != null) {
            return `${userProfile.maxAge} ${ageUnit}`;
        }

        return null;
    }

    static getUserProfilePersonsInfo(
        userProfile: Pick<UserProfileInfo, 'minNumberOfPersons' | 'maxNumberOfPersons'>,
        translate: TranslateInstant
    ): string | null {
        const personsLabel = translate.instant('PURCHASE_V2_PRODUCT_USER_PROFILE_PERSONS_UNIT');

        if (userProfile?.minNumberOfPersons != null && userProfile?.maxNumberOfPersons != null) {
            return `${userProfile.minNumberOfPersons}-${userProfile.maxNumberOfPersons} ${personsLabel}`;
        }

        if (userProfile?.minNumberOfPersons != null) {
            return `${userProfile.minNumberOfPersons}+ ${personsLabel}`;
        }

        if (userProfile?.maxNumberOfPersons != null) {
            return `${userProfile.maxNumberOfPersons} ${personsLabel}`;
        }

        return null;
    }
}
